"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.couponSchema = exports.couponInitialized = void 0;
const joi_1 = __importDefault(require("joi"));
const joiMessages_1 = require("../data/joiMessages");
const validations_1 = require("../data/validations");
exports.couponInitialized = {
    percentage: undefined,
    amount: undefined,
    originalAmount: undefined,
    name: "",
    description: "",
    from: "",
    to: "",
    imageLink: null,
    type: 'PRICE',
    twoForOne: false,
    oneTimeUse: false,
    isMain: false,
    monday: false,
    tuesday: false,
    wednesday: false,
    thursday: false,
    friday: false,
    saturday: false,
    sunday: false,
    isActive: false,
};
exports.couponSchema = joi_1.default.object({
    percentage: joi_1.default.number().optional(),
    amount: joi_1.default.number().optional(),
    originalAmount: joi_1.default.number().optional(),
    name: joi_1.default.string().max(50).required().messages({
        ...(0, joiMessages_1.joiStringMessage)({ name: 'Name (English)', isRequired: true }),
    }),
    description: joi_1.default.string().required().max(1500).messages({
        ...(0, joiMessages_1.joiStringMessage)({ name: 'Description (English)' }),
    }),
    from: joi_1.default.string().optional().pattern(validations_1.militaryTimeRegex).min(3).max(5).messages({
        ...(0, joiMessages_1.joiStringMessage)({ name: 'From', patternText: 'has to be on the form "hh:mm" such as 13:05' }),
    }),
    to: joi_1.default.string().optional().pattern(validations_1.militaryTimeRegex).min(3).max(5).messages({
        ...(0, joiMessages_1.joiStringMessage)({ name: 'To', patternText: 'has to be on the form "hh:mm" such as 13:05' }),
    }),
    imageLink: joi_1.default.any().optional(),
    type: joi_1.default.string().valid('PRICE', 'PERCENTAGE', 'TWO_FOR_ONE').required(),
    twoForOne: joi_1.default.boolean(),
    oneTimeUse: joi_1.default.boolean(),
    isMain: joi_1.default.boolean(),
    monday: joi_1.default.boolean(),
    tuesday: joi_1.default.boolean(),
    wednesday: joi_1.default.boolean(),
    thursday: joi_1.default.boolean(),
    friday: joi_1.default.boolean(),
    saturday: joi_1.default.boolean(),
    sunday: joi_1.default.boolean(),
    isActive: joi_1.default.boolean(),
});
